import { api } from "../api";


export const SHOP_PRODUCT_BATCH_SIZE = 50;


function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value !== null && typeof value !== "undefined")
  );
}


export async function fetchShopSklads() {
  const { data } = await api.get("shop/sklads/");
  return Array.isArray(data) ? data : [];
}


export async function fetchShopCategories() {
  const { data } = await api.get("shop/categories/");
  return data;
}


export async function fetchShopBrands() {
  const { data } = await api.get("shop/brands/");
  return data;
}


export async function fetchShopProducts(params = {}) {
  const { data } = await api.get("shop/products/", { params: cleanParams(params) });
  return data;
}


export async function fetchShopProductBatch(params = {}) {
  const batchSize = params.limit != null ? params.limit - 1 : SHOP_PRODUCT_BATCH_SIZE;
  const data = await fetchShopProducts({
    ...params,
    limit: batchSize + 1,
  });

  return {
    items: data.slice(0, batchSize),
    hasMore: data.length > batchSize,
  };
}


export async function fetchShopProduct(slug) {
  const { data } = await api.get(`shop/products/${slug}/`);
  return data;
}


export async function createShopOrder(payload) {
  const { data } = await api.post("shop/orders/", payload);
  return data;
}


export async function fetchAdminShopOrders(params = {}) {
  const { data } = await api.get("shop/admin/orders/", { params: cleanParams(params) });
  return data;
}


export async function fetchAdminShopOrder(groupToken) {
  const { data } = await api.get(`shop/admin/orders/${encodeURIComponent(groupToken)}/`);
  return data;
}


export async function createAdminShopOrder(payload) {
  const { data } = await api.post("shop/admin/orders/", payload);
  return data;
}


export async function updateAdminShopOrder(groupToken, payload) {
  const { data } = await api.put(`shop/admin/orders/${encodeURIComponent(groupToken)}/`, payload);
  return data;
}


export async function confirmAdminShopOrder(groupToken, payload) {
  const { data } = await api.post(`shop/admin/orders/${encodeURIComponent(groupToken)}/confirm/`, payload);
  return data;
}
